import {
  baseScreen,
} from 'hoc';
import React,
{
  useRef,
  useState,
} from 'react';
import GeneralTableView from 'src/components/GeneralTableView';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  toJS,
} from 'mobx';
import {
  FilterTypes,
  TableColumnTypes,
} from 'src/components/GeneralTableView/types';
import {
  useHistory,
} from 'react-router';
import {
  Assets,
} from 'assets';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import {
  BillStatus,
} from 'src/stores/backend/BillsStore/types';
import {
  Button,
} from '@material-ui/core';
import SearchFilterDropdown from 'src/components/SearchFilterComponent';
import FilterListIcon from '@material-ui/icons/FilterList';
import DateRange from 'src/components/DateRange';
import {
  Bill,
  ListFilter,
} from './types';
import {
  ListFilter as RequestTypeListFilter,
} from '../hospitals/types';

const doctorsBalance: React.FC = () => {
  const {
    backend: {
      billsStore,
    },
  } = useStores();
  const ref = useRef<any|null>(null);
  const [
    currentFilter,
    setCurrentFilter,
  ] = useState<ListFilter>(ListFilter.ALL);
  const [
    currentTypeFilter,
    setCurrentTypeFilter,
  ] = useState('all');
  const [
    filterDisplayed,
    setFilterDisplayed,
  ] = useState(false);
  const [
    range,
    setRange,
  ] = useState<{
    min: Date,
    max: Date,
  }>({} as any);
  const history = useHistory();
  const onFilterChange = (val: ListFilter) => {
    setCurrentFilter(val);
    ref.current?.onQueryChange();
  };
  const onTypeFilterChange = (val: RequestTypeListFilter) => {
    setCurrentTypeFilter(val);
    ref.current?.onQueryChange();
  };
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => setFilterDisplayed(!filterDisplayed)}
        tabIndex={0}
        role="button"
        onDoubleClick={() => {
          setFilterDisplayed(!filterDisplayed);
        }}
        onKeyDown={() => {
        }}
      >
        <span
          style={{
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {i18n.t('FILTER')}
        </span>
        <FilterListIcon />
      </div>
      {filterDisplayed && (
        <div>
          <SearchFilterDropdown
            label={i18n.t('TRANSACTION_TYPE')}
            style={{
              margin: 16,
            }}
            searchFilterDropdown={{
              filters: [
                {
                  name: i18n.t('ALL'),
                  value: ListFilter.ALL,
                },
                {
                  name: i18n.t('BANK_ACCOUNT'),
                  value: ListFilter.BANK_ACCOUNT,
                },
                {
                  name: i18n.t('WALLET'),
                  value: ListFilter.WALLET,
                },
              ],
              value: currentFilter || ListFilter.ALL,
              initialValue: currentFilter || ListFilter.ALL,
              onChange: onFilterChange,
            }}
          />
          <SearchFilterDropdown
            label={i18n.t('CONSULTATION_TYPE')}
            style={{
              margin: 16,
            }}
            searchFilterDropdown={{
              filters: [
                {
                  name: i18n.t('ALL'),
                  value: 'all',
                },
                {
                  name: i18n.t('HOME_VISITS'),
                  value: RequestTypeListFilter.HOME_VISIT,
                }, {
                  name: i18n.t('ONLINE_CONSULTATION'),
                  value: RequestTypeListFilter.ONLINE_CONSULTATION,
                },
                {
                  name: i18n.t('CLINICS'),
                  value: RequestTypeListFilter.CLINICS,
                },
              ],
              value: currentFilter || ListFilter.ALL,
              initialValue: currentFilter || ListFilter.ALL,
              onChange: onTypeFilterChange,
            }}
          />

          <DateRange
            onChange={async (start, end) => {
              await setRange({
                min: start,
                max: end,
              });
              ref.current?.onQueryChange();
            }}
          />
          <div
            style={{
              justifyContent: 'flex-end',
              display: 'flex',
              marginBottom: 16,
            }}
          >
            <Button
              style={{
                background: '#3f51b5',
                color: '#FFF',
              }}
              onClick={async () => {
                await setFilterDisplayed(false);
                await setRange({} as any);
                await setCurrentFilter(ListFilter.ALL);
                ref.current?.onQueryChange();
              }}
            >
              {i18n.t('RESET')}
            </Button>
          </div>
        </div>
      )}

      <GeneralTableView<Bill>
        tableProps={{
          tableRef: ref,
          options: {
            actionsColumnIndex: 10,
            search: true,
            paging: true,
          },
          title: i18n.t('BALANCE'),
          actions: [
            {
              isFreeAction: true,
              icon: ImportExportIcon,
              onClick: () => {
                window.open(billsStore.download(), '_blanck');
              },
              tooltip: i18n.t('EXPORT_DATA'),
            },
            {
              icon: () => (
                <img
                  src={Assets.images.common.eye}
                  alt={i18n.t('VIEW')}
                />
              ),
              onClick: async (ev, data) => {
                const bill: any = data;
                history.push(`/balance/balance/doctors/weekly-breakdown/${bill.doctorId}`);
              },
            },
          ],
        }}
        options={{
          search: false,
          pageSize: 10,
          filtering: false,
        }}
        get={async (query) => {
          const queryObj: any = {
            ...query, filters: [],
          };
          if (currentFilter !== ListFilter.ALL) {
            queryObj.filters.push({
              type: 'FIXED',
              by: 'payment_method',
              value: currentFilter,
            });
          }
          if (range.min) {
            queryObj.filters.push({
              type: 'RANGE',
              by: 'date',
              min: range.min,
              max: range.max,
            });
          }
          if (currentTypeFilter !== 'all') {
            queryObj.filters.push({
              type: 'FIXED',
              by: 'consultation_type',
              value: currentTypeFilter,
            });
          }
          await billsStore.entityList.updateOptions(queryObj);
          return {
            data: toJS(billsStore.entityList.data).map((item) => new Bill(item)),
            totalCount: billsStore.entityList.meta.itemCount,
            page: billsStore.entityList.meta.page - 1,
          };
        }}
        tableColumns={[
          {
            field: 'id',
            title: i18n.t('ID'),
            type: TableColumnTypes.NUMERIC,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'date',
            title: i18n.t('DUE_DATE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'name',
            title: i18n.t('DOCTOR'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'mobileNumber',
            title: i18n.t('MOBILE_NUMBER'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'balance',
            title: i18n.t('BALANCE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'status',
            title: i18n.t('STATUS'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
            columnProps: {
              render: (data) => (data.status === BillStatus.SETTLED
                ? (<p>{data.status}</p>) : (
                  <Button
                    onClick={() => {
                      history.push(`/balance/hospitals/settlement/${data.id}`);
                    }}
                    style={{
                      background: '#3f51b5',
                      color: '#FFF',
                    }}
                  >
                    {i18n.t('SETTLE')}
                  </Button>
                )),
            },
          },
        ]}
      />
    </div>
  );
};

export const DoctorsBalance = baseScreen(doctorsBalance, {
  allowedRoles: ['ADMIN', 'NONE'],
});
